module.exports = __webpack_public_path__ + "media/old_images/default-site-category-club-house-cc192d40.png";